module.exports = __webpack_public_path__ + "static/media/160Mbps.436bb57e.bin";